import { AuthConfig } from "angular-oauth2-oidc";
import { Environment } from "./env.model";

const clientID = '4novojpshntbgfk5m6jedhat2q';
const issuer = 'https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_iCZILQmny';

const authCodeFlowConfig: AuthConfig = {
  issuer,

  strictDiscoveryDocumentValidation: false,

  redirectUri: 'https://search.dev.tebitask.tebis.cloud/',
  logoutUrl: 'https://search.dev.tebitask.tebis.cloud/',

  clientId: clientID,

  oidc: true,
  responseType: 'code',

  scope: 'openid profile email',

  showDebugInformation: true,
};

export const environment: Environment = {
    name: "Development - Search Test",
    baseUrl: '',
    baseUrlRds: 'https://api.dev.tebitask.tebis.cloud/api',
    clientID,
    issuer,
    authCodeFlowConfig,
    clientIDSourceUrl: 'https://api.test.tebiauth.tebis.cloud/clientids/tebitask',
};
